import React from 'react';
import { CheckIcon } from 'lucide-react';
import { toolkitBonuses, useCases } from '../data/offer';
export function Toolkit() {
  return <section aria-labelledby="toolkit-title" className="bg-white" data-id="element-317" data-mp="3jdcot9o6qudw">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 py-16 sm:py-20 lg:grid-cols-2 lg:gap-16" style={{
      paddingTop: "19px",
      paddingBottom: "23px"
    }} data-id="element-318" data-mp="1w397j8hp37x">
        <div data-id="element-319" data-mp="3t7uswfxikry8">
          <h2 id="toolkit-title" className="font-display text-2xl font-black text-ink sm:text-3xl" data-id="element-320" data-mp="avg8jj2wgbex">
            Your complete Realtor AI toolkit
          </h2>
          <dl className="mt-8 divide-y divide-line border-y border-line" data-id="element-321" data-mp="5wdesusddrm9">
            <div className="flex items-baseline justify-between gap-4 py-5" data-id="element-322" data-mp="ksulh8pm6i2h">
              <dt className="text-sm font-semibold text-muted" data-id="element-323" data-mp="fu9pxmlb4mkd">Main System</dt>
              <dd className="font-display text-lg font-extrabold text-ink" data-id="element-324" data-mp="2ml95qefmrym2">100 AI Prompts</dd>
            </div>
            <div className="py-5" data-id="element-325" data-mp="2hmfrgjsis3ku">
              <div className="flex items-baseline justify-between gap-4" data-id="element-326" data-mp="2hnhapbjovwdn">
                <dt className="text-sm font-semibold text-muted" data-id="element-327" data-mp="20107l32efwtl">Bonuses</dt>
                <dd className="font-display text-lg font-extrabold text-ink" data-id="element-328" data-mp="241j1r3rrleyy">5 Professional Bonuses</dd>
              </div>
              <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-329" data-mp="290n87mnb0yll">
                {toolkitBonuses.map(b => <li key={b} className="flex items-center gap-2 text-sm text-ink" data-id="element-330" data-mp="2ds5bihcsvb9q">
                    <CheckIcon className="h-4 w-4 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-331" data-mp="2iqovwdbqwezz" />
                    {b}
                  </li>)}
              </ul>
            </div>
          </dl>
          <p className="mt-5 text-sm text-muted" data-id="element-332" data-mp="2rrmtodvlbqa4">Everything organized in one practical digital system.</p>
        </div>

        <div data-id="element-333" data-mp="2wqpzw1nb42jo">
          <h2 className="font-display text-2xl font-black text-ink sm:text-3xl" data-id="element-334" data-mp="2wp6iu8tttngu">Access everything from your laptop, tablet or phone</h2>
          <p className="mt-4 text-sm font-semibold text-muted" data-id="element-335" data-mp="xfgel3zkspcj">Whether you’re:</p>
          <ul className="mt-4 grid gap-3 sm:grid-cols-2" data-id="element-336" data-mp="12cp27k3htll6">
            {useCases.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-3 text-[15px] text-ink" data-id="element-337" data-mp="25p77n7rpl4e9">
                <Icon className="h-4 w-4 shrink-0 text-cyan-ink" aria-hidden="true" data-id="element-338" data-mp="20qchtlvbqfkn" />
                {label}
              </li>)}
          </ul>
          <p className="mt-6 text-base font-semibold text-ink" data-id="element-339" data-mp="29ofyo4vd6o64">You can open the relevant framework and start working.</p>
        </div>
      </div>
    </section>;
}